(function($){

  $('.button-escape').click(function(e) {
    window.open('https://www.google.com/', '_blank');
    window.open('https://www.weather.com/', '_self');
  });

})(jQuery); 